import { useEffect } from "react";
import { inventoryActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const useGetProductListInWareHouse = (
    params: {
        path: { warehouseId: string };
        query: {
            category: string;
            search: string;
        };
    },
    options: { skip?: boolean }
) => {
    const dispatch = useAppDispatch();
    const { skip } = options;

    const {
        fetchingInventoryListInWarehouse,
        fetchedInventoryListInWarehouseSuccess,
        fetchedInventoryListInWarehouseFailure,
    } = useAppSelector((state) => state.inventory);

    const handleFetchInventories = (params: {
        path: { warehouseId: string };
        query: {
            category: string;
            search: string;
        };
    }) => {
        dispatch(inventoryActions.getInventoryListInWarehouse(params));
    };

    useEffect(() => {
        if (!skip) {
            handleFetchInventories(params);
        }
    }, [params, skip]);

    return {
        isSuccess: fetchedInventoryListInWarehouseSuccess,
        isError: fetchedInventoryListInWarehouseFailure,
        isLoading: fetchingInventoryListInWarehouse,
        data: fetchedInventoryListInWarehouseSuccess,
        error: fetchedInventoryListInWarehouseFailure,
        refetch: () => handleFetchInventories(params),
    };
};

export default useGetProductListInWareHouse;
